import { FILE_EXTENSIONS, IMAGE_EXTENSIONS } from 'Common/Constants'
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import React, { useEffect, useState } from 'react'
import { Base64ToBlob } from 'Utils/Utils'

const extractBase64=(dataUri)=> {
    if (typeof dataUri !== "string") return null;
    const commaIndex = dataUri.indexOf(",");
    if (commaIndex === -1) return null; // no base64 part found
    return dataUri.slice(commaIndex + 1);
}

const FileAttachmentViewer = ({ onClose, viewAttachment, disableDraggable }) => {
    const uniqueId = "FileAttachmentViewer"
    const [showHcfa, setShowHcfa] = useState(false)
    const [showTxt, setShowTxt] = useState(false)
    const [show835, setShow835] = useState("")
    const fileExtension = viewAttachment.fileExtension
        ? viewAttachment.fileExtension.toLowerCase()
        : '';
    useEffect(() => {
        let base64File
        let base

        if (viewAttachment.Attachment) {
            if (fileExtension === FILE_EXTENSIONS.PDF) {
                base = viewAttachment.Attachment.replace(/['"]+/g, '')
                const base64File = extractBase64(viewAttachment.Attachment)
                const blob = Base64ToBlob(base64File || base, "application/pdf");
                const url = URL.createObjectURL(blob);
                setShowHcfa(url);
            } else if (fileExtension === FILE_EXTENSIONS.TXT) {
                base = viewAttachment.Attachment.replace(/['"]+/g, '')

                const prefix = 'data:text/plain;base64,';
                if (base.startsWith(prefix)) {
                    base64File = base.slice(prefix.length);
                }
                const blob = Base64ToBlob(base64File || base, "text/plain");
                const url = URL.createObjectURL(blob);
                setShowTxt(url);
            } else if (fileExtension === FILE_EXTENSIONS.EDI_835) {
                base = viewAttachment.Attachment.replace(/['"]+/g, '')
                const prefix = 'data:application/octet-stream;base64,';
                if (base.startsWith(prefix)) {
                    base64File = base.slice(prefix.length);
                }
                const blob = Base64ToBlob(base64File || base, "text/plain");
                const url = URL.createObjectURL(blob);
                setShow835(url);
            }
        }
    }, [viewAttachment.Attachment, fileExtension])

    return (
        <ReactPortal wrapperId={uniqueId}>
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-[900px]  min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            View Attachment
                            <button onClick={onClose} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                                <img src="/img/crossblack.svg" alt="cross" />
                            </button>
                        </div>

                        <div className="px-4 sm:px-5 pt-5 overflow-y-auto max-h-[70vh]">
                            {fileExtension ? (
                                fileExtension === FILE_EXTENSIONS.PDF
                                    ? (
                                        <div className="w-full flex justify-center">
                                            <iframe
                                                title="HCFA File"
                                                style={{ border: 'none' }}
                                                src={`${showHcfa}#toolbar=1&navpanes=1`}
                                                className="w-full max-w-5xl h-[60vh] min-h-[320px]"
                                                type="application/pdf"
                                            />
                                        </div>
                                    )
                                    : fileExtension === FILE_EXTENSIONS.TXT
                                        ? (
                                            <div className="w-full flex justify-center">
                                                <iframe
                                                    title="HCFA File"
                                                    style={{ border: 'none' }}
                                                    src={`${showTxt}#toolbar=1&navpanes=1`}
                                                    className="w-full max-w-5xl h-[60vh] min-h-[320px]"
                                                    type="text/plain"
                                                />
                                            </div>
                                        )
                                        : IMAGE_EXTENSIONS.includes(fileExtension)
                                            ? (
                                                <div className="w-full flex justify-center">
                                                    <img
                                                        className="block w-full max-w-5xl max-h-[60vh] object-contain rounded-lg cursor-pointer"
                                                        src={`${viewAttachment.Attachment}`}
                                                        alt={`${viewAttachment.fileExtension} pic`}
                                                    />
                                                </div>
                                            )
                                            : fileExtension === FILE_EXTENSIONS.EDI_835
                                                ? (
                                                    <div className="w-full flex justify-center">
                                                        <iframe
                                                            title="HCFA File"
                                                            style={{ border: 'none' }}
                                                            src={`${show835}#toolbar=1&navpanes=1`}
                                                            className="w-full max-w-5xl h-[60vh] min-h-[320px]"
                                                        />
                                                    </div>
                                                )
                                                : (<span className='flex justify-center mt-12 text-2xl'>
                                                    No Proper Extension found !
                                                </span>)
                            ) :
                                (
                                    <span className='flex justify-center mt-12 text-2xl'>
                                        File not found !
                                    </span>
                                )}
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                            <CustomButtonNew label={"Cancel"} variant={"outline"} onClick={() => onClose()} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default FileAttachmentViewer